import { urlsPages } from "../../common/urls/urls-pages";
import { DrillCode } from "../drills/application/domain/drill-code";

import { ButtonPrimary, StatCard } from "../../common";
import { FaDumbbell } from "react-icons/fa";
import { FooterContent } from "./style";

type WorkoutDetailsItemProps = {
    id: string;
    name: string;
    onDelete: () => void;
    drillCode?: DrillCode;
}

export const WorkoutItem: React.FC<WorkoutDetailsItemProps> = ({ id, name, onDelete, drillCode }) => {
    const startPage = drillCode === DrillCode.ARROW_RIGHT_LEFT ? urlsPages.connection : urlsPages.actions;
    const page = startPage.replace(":workoutId", id)
    return <StatCard
        title={name}
        description=""
        stats={[]}
        onClose={onDelete}
        leadingIcon={<FaDumbbell />}
        footerContent={
            <FooterContent>
                <ButtonPrimary
                    width="80px"
                    height="43px"
                    margintop="5px"
                    marginbottom="0"
                    goToPage={page}
                >
                    Iniciar
                </ButtonPrimary>
            </FooterContent>
        }
    />
}